"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=go-back-rule.js.map